import { EventEmitter, NgZone } from '@angular/core';
import { Deferred } from '../../shared/helpers/deferred';
import { FIRST_LAYER_ID } from '../../constants';
import { MessageType } from '../../../../worker/src/message-type';
var instance;
var RecorderStore = /** @class */ (function () {
    function RecorderStore(zone) {
        var _this = this;
        this.worker = new Worker('assets/worker.js');
        this.queue = [];
        this.recordData = {
            length: 0,
            layerIds: [
                FIRST_LAYER_ID,
            ],
        };
        this.historyData = {
            appliedTransactionsNumber: 0,
            rollbackTransactionsNumber: 0,
        };
        this.onRecordChange = new EventEmitter();
        this.onLayerChange = new EventEmitter();
        this.onSampleFinish = new EventEmitter();
        this.onHistoryChange = new EventEmitter();
        if (instance) {
            return instance;
        }
        else {
            instance = this;
        }
        this.worker.addEventListener('message', function (event) { return zone.run(function () {
            _this.onMessage(event);
        }); });
        this.onRecordChange.subscribe(function (recordData) { return _this.recordData = recordData; });
        this.onHistoryChange.subscribe(function (historyData) { return _this.historyData = historyData; });
    }
    Object.defineProperty(RecorderStore.prototype, "lastLayerId", {
        get: function () {
            var layerIds = this.recordData.layerIds;
            return layerIds[layerIds.length - 1];
        },
        enumerable: true,
        configurable: true
    });
    RecorderStore.prototype.undo = function () {
        return this.postMessage(MessageType.UNDO);
    };
    RecorderStore.prototype.redo = function () {
        return this.postMessage(MessageType.REDO);
    };
    RecorderStore.prototype.getLevels = function (payload) {
        return this.postPromiseMessage(MessageType.GET_LEVELS, payload);
    };
    RecorderStore.prototype.getRecordLength = function () {
        return this.postPromiseMessage(MessageType.GET_RECORD_LENGTH);
    };
    RecorderStore.prototype.addRecordingProgress = function (float32Array) {
        return this.postPromiseMessage(MessageType.ADD_RECORDING_PROGRESS, float32Array);
    };
    RecorderStore.prototype.startRecording = function (payload) {
        this.postMessage(MessageType.START_RECORDING, payload);
    };
    RecorderStore.prototype.addLayer = function () {
        return this.postPromiseMessage(MessageType.ADD_LAYER);
    };
    RecorderStore.prototype.removeLayer = function (layerId) {
        return this.postPromiseMessage(MessageType.REMOVE_LAYER, layerId);
    };
    RecorderStore.prototype.stopRecording = function () {
        return this.postPromiseEventMessage(MessageType.STOP_RECORDING, 'onSampleFinish');
    };
    RecorderStore.prototype.postPromiseEventMessage = function (messageType, eventName, payload) {
        var _this = this;
        var promise = this.postPromiseMessage(messageType, payload);
        promise.then(function (data) { return _this[eventName].emit(data); });
        return promise;
    };
    RecorderStore.prototype.getRecordData = function (startPosition) {
        return this.postPromiseMessage(MessageType.GET_RECORD_DATA, startPosition);
    };
    RecorderStore.prototype.getCompiledRecord = function () {
        return this.postPromiseMessage(MessageType.GET_COMPILED_RECORD);
    };
    RecorderStore.prototype.setLayerVolume = function (payload) {
        this.postMessage(MessageType.SET_LAYER_VOLUME, payload);
    };
    RecorderStore.prototype.postPromiseMessage = function (type, payload) {
        var deferred = new Deferred();
        this.queue.push(deferred);
        this.postMessage(type, payload);
        return deferred.promise;
    };
    RecorderStore.prototype.postMessage = function (type, payload) {
        this.worker.postMessage({ type: type, payload: payload });
    };
    RecorderStore.prototype.onMessage = function (event) {
        if (!event.data) {
            return;
        }
        var data = event.data;
        switch (data.type) {
            case MessageType.ON_RECORD_CHANGE:
                this.onRecordChange.emit(data.payload);
                break;
            case MessageType.ON_LAYER_CHANGE:
                this.onLayerChange.emit(data.payload);
                break;
            case MessageType.ON_HISTORY_CHANGE:
                this.onHistoryChange.emit(data.payload);
                break;
            default:
                this.queue.shift()
                    .resolve(data.payload);
        }
    };
    return RecorderStore;
}());
export { RecorderStore };



// WEBPACK FOOTER //
// ./src/app/rec/stores/recorder.store.ts.pre-build-optimizer.js